import { Skeleton } from "components/ui/skeleton";

export function TemplateCardSkeleton() {
    return (
        <article className="flex flex-col bg-surface dark:bg-gray-900 border border-line dark:border-gray-800 rounded-xl overflow-hidden">
            {/* Thumbnail */}
            <div className="relative min-h-[120px] max-h-52 bg-gray-100 dark:bg-gray-800">
                <Skeleton className="absolute inset-0 !rounded-none" />
            </div>

            {/* Footer — matches px-3 pt-2.5 pb-2 */}
            <div className="px-3 pt-2.5 pb-2">
                {/* Row 1: Name + three-dot */}
                <div className="flex items-center justify-between gap-1.5">
                    <Skeleton variant="text" className="!h-3.5 !w-3/4" />
                    <Skeleton className="h-5 w-5 rounded-md flex-shrink-0" />
                </div>

                {/* Row 2: Description */}
                <Skeleton variant="text" className="!h-2.5 !w-full mt-1.5" />

                {/* Row 3: Tag badge + date */}
                <div className="flex items-center gap-1.5 mt-2">
                    <Skeleton className="h-4 w-14 rounded" />
                    <Skeleton variant="text" className="!h-2.5 !w-10" />
                </div>
            </div>
        </article>
    );
}

export function TemplateCardGridSkeleton({ count = 8 }: { count?: number }) {
    return (
        <div
            id="template-grid-skeleton"
            className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5 gap-3"
            role="grid"
            aria-label="Loading templates"
        >
            {Array.from({ length: count }).map((_, i) => (
                <TemplateCardSkeleton key={i} />
            ))}
        </div>
    );
}





export function TemplateEditorSkeleton() {
    return (
        <div className="px-4 pt-3 pb-20 fade-in">
            <div className="card rounded-2xl">
                <div className="w-full h-full px-4 pt-4">
                    {/* --- Form Row --- */}
                    <div className="w-full flex flex-wrap gap-3 pb-3">
                        <div className="flex flex-1 items-center min-w-[280px]">
                            <Skeleton className="!h-4 !w-[130px] mr-3" />
                            <Skeleton className="h-9 w-full rounded-lg" />
                        </div>
                        <div className="flex flex-1 items-center min-w-[280px]">
                            <Skeleton className="!h-4 !w-[130px] mr-3" />
                            <Skeleton className="h-9 w-full rounded-lg" />
                        </div>
                    </div>

                    {/* --- Editor/Preview block --- */}
                    <div className="mt-3 border border-line dark:border-dark-600 rounded-xl">
                        <Skeleton className="h-[480px] w-full rounded-xl" />
                    </div>
                </div>

                {/* --- Footer actions --- */}
                <div className="pt-4 pb-3 pr-2 flex justify-end gap-2">
                    <Skeleton className="h-9 w-24 rounded-lg" />
                    <Skeleton className="h-9 w-32 rounded-lg" />
                    <Skeleton className="h-9 w-36 rounded-lg" />
                </div>
            </div>
        </div>
    );
}
